import React from 'react';

const PixarCategory = () => {
    return(
        <div className='cards-categories'>
            <div>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/29859918D787A9A644D348B59AB90854C58DFD65DE68C50B9FBA28C423405167/scale?width=400&aspectRatio=1.78&format=jpeg" alt="" />
            </div>

            <div>
                <a></a>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/BB89C5769A6867177704F330547054D2DFCC1C50299968CF55BF70C420695AC1/scale?width=400&aspectRatio=1.78&format=jpeg" alt="" />
            </div>
                
            <div>
                <a></a>    
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/E92E744CD9FFAAE05A837B003C8F1F2124930BA475534AB6118F6B33D4A1DE6B/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal" alt="" />
            </div>
                
            <div>
                <a></a>
                <img src="https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/C9A38B17830BF1BCB4F069F4EF17C7316AAF10861B2EBE906583FE5CEC5960DB/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal" alt="" />
            </div>
        </div>
    )
}

export default PixarCategory;